var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSucLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5204 0.475539C12.2555 0.171057 13.0814 0.171056 13.8165 0.475538L20.0057 3.03918C20.7408 3.34366 21.3248 3.92768 21.6293 4.66277L24.1929 10.8519C24.4974 11.587 24.4974 12.413 24.1929 13.1481L21.6293 19.3372C21.3248 20.0723 20.7408 20.6563 20.0057 20.9608L13.8165 23.5245C13.0814 23.8289 12.2555 23.8289 11.5204 23.5245L5.33123 20.9608C4.59614 20.6563 4.01212 20.0723 3.70764 19.3372L1.144 13.1481C0.839514 12.413 0.839513 11.587 1.144 10.8519L3.70764 4.66277C4.01212 3.92769 4.59614 3.34366 5.33123 3.03918L11.5204 0.475539Z",
    fill: "#1DC295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8067 7.37504C19.2891 7.87425 19.2891 8.67909 18.8067 9.17829L11.6052 16.6256C11.1228 17.1248 10.3451 17.1248 9.8627 16.6256L6.53025 13.1719C6.04786 12.6727 6.04786 11.8679 6.53025 11.3687C7.01264 10.8695 7.79038 10.8695 8.27277 11.3687L10.7389 13.9207L17.0691 7.36995C17.5465 6.87584 18.3243 6.87584 18.8067 7.37504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucLoad);
export default __webpack_public_path__ + "static/media/suc-load.17d202c4592e931ff1e7432a823cb671.svg";
export { ForwardRef as ReactComponent };